__turbopack_context__.v({
  "category": "footer-links-module-scss-module__s0Ct0G__category",
  "link-item": "footer-links-module-scss-module__s0Ct0G__link-item",
  "links": "footer-links-module-scss-module__s0Ct0G__links",
  "links-row": "footer-links-module-scss-module__s0Ct0G__links-row",
});
